export interface INumberListItem {
    value: number;
    text: string;
    selected: boolean;
}